var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
function SvgPlayTriangle(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "playTriangle_svg__a",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#d9d9d9",
    d: "M0 0h32v32H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#playTriangle_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M10.666 25.333V6.667L25.333 16zm2.667-4.866l7-4.467-7-4.467z"
  }))));
}
export default SvgPlayTriangle;